import React, { useContext } from "react";
import AlertModal from "../components/AlertModal";
import ModalContext from "../../../shared/context/ModalContext";

// Only used for modals that are to be clicked and thereby manually activated
const useModal = () => {
    const modalContext = useContext(ModalContext);

    const showModal = (message, title, automaticModal, onYes, buttonText) => {
        modalContext.showModal(
            <AlertModal
                message={message}
                onYes={onYes || null}
                automaticModal={automaticModal}
                buttonText={buttonText}
            />,
            {
                title: title,
                hideClose: automaticModal,
            }
        );
    };

    return { showModal };
};

export default useModal;
